import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, Link } from 'react-router-dom';

const Footer = () => {
    const { t } = useTranslation();
    const { lang } = useParams();

    return (
        <footer className="main-footer">
            <div className="container footer-container">
                <div className="footer-brand">
                    <Link to={`/${lang}`} style={{ display: 'flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}>
                        <img src="/assets/logo.png" alt="NPU Universe" style={{ height: '30px', opacity: 0.8 }} />
                    </Link>
                    <span style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>© 2026 NPU Universe</span>
                </div>
                
                <div className="footer-links">
                    <Link to={`/${lang}/company`}>{t('company.title')}</Link>
                    <Link to={`/${lang}/privacy`}>{t('footer.privacy')}</Link>
                    <Link to={`/${lang}/terms`}>{t('footer.terms')}</Link>
                </div>
            </div>
        </footer>
    );
};

export default Footer;

